import { plainToClassFromExist, Expose } from 'class-transformer';

import { ViewContainerRef } from '@angular/core';

import { ExposeRawData, Default } from '@lib/common/decorators';

import { SnDrawerMode } from '../types/drawer-mode.type';
import { SnDrawerPosition } from '../types/drawer-position.type';

export class SnDrawerConfig<D = any> {
  @Expose()
  public id?: string;

  @Expose()
  @ExposeRawData()
  public data?: D;

  @Expose()
  @Default('modal')
  public mode?: SnDrawerMode;

  @Expose()
  @Default('right')
  public position?: SnDrawerPosition;

  @Expose()
  @Default(380)
  public width?: number;

  @Expose()
  @ExposeRawData()
  public viewContainerRef?: ViewContainerRef;

  @Expose()
  @Default(true)
  public hasBackdrop?: boolean;

  @Expose()
  @Default(false)
  public disableClose?: boolean;

  @Expose()
  @ExposeRawData()
  public backdropClass?: string | string[];

  @Expose()
  @ExposeRawData()
  public panelClass?: string | string[];

  @Expose()
  @Default(true)
  public closeOnNavigation?: boolean;

  constructor(data: SnDrawerConfig) {
    plainToClassFromExist(this, data, { strategy: 'excludeAll' });
  }
}
